import {
  errorBuyNowArray,
  errorDefaultBuyNow,
  errorDefaultBuyNowCartEmpty,
  errorDefaultBuyNowDelivery,
  errorDefaultBuyNowDemand,
  errorDefaultBuyNowGiftCard,
  errorDefaultBuyNowPayment,
  errorDefaultBuyNowShipping,
  ErrorTypeBuyNow
} from './buy-now-error-handler.constants';
import type {
  IErrorHandlerBuyNow,
  IErrorResponse
} from './buy-now-error-handler.interfaces';

export const errorHandlerBuyNow = (
  originError?: IErrorResponse
): IErrorHandlerBuyNow => {
  if (!originError) return errorDefaultBuyNow;

  const errorCopy = structuredClone(originError);
  if (errorCopy?.error?.meta?.cartId) {
    errorCopy.error.meta.cartId = '';
  }
  const errorStringWithoutCartId = JSON.stringify(errorCopy);

  const error = errorBuyNowArray?.find((elm) =>
    errorStringWithoutCartId.includes(elm?.originError || elm?.errorCode || '')
  );

  if (error) {
    return {
      ...error,
      originalErrorResponse: originError
    };
  }

  if (originError?.error?.meta?.errorCode?.includes('CHK')) {
    const errorMap = { ...errorDefaultBuyNowPayment };
    errorMap.errorCode = originError?.error?.meta?.errorCode;
    errorMap.originalErrorResponse = originError;
    return errorMap;
  }

  switch (originError?.error?.type) {
    case ErrorTypeBuyNow.DELIVERY:
      return {
        ...errorDefaultBuyNowDelivery,
        originalErrorResponse: originError
      };
    case ErrorTypeBuyNow.PAYMENT:
      return {
        ...errorDefaultBuyNowPayment,
        originalErrorResponse: originError
      };
    case ErrorTypeBuyNow.SHIPPING:
      return {
        ...errorDefaultBuyNowShipping,
        originalErrorResponse: originError
      };
    case ErrorTypeBuyNow.DEMAND:
      return {
        ...errorDefaultBuyNowDemand,
        originalErrorResponse: originError
      };
    case ErrorTypeBuyNow.GIFTCARD:
      return {
        ...errorDefaultBuyNowGiftCard,
        originalErrorResponse: originError
      };
    case ErrorTypeBuyNow.CART_IS_EMPTY:
      return {
        ...errorDefaultBuyNowCartEmpty,
        originalErrorResponse: originError
      };
    default:
      return {
        ...errorDefaultBuyNow,
        originalErrorResponse: originError
      };
  }
};
